'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  IsomorphicCSSProvider: {
    displayName: 'IsomorphicCSSProvider'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/runner/work/redux-frontend/redux-frontend/src/helpers/IsomorphicCSSProvider.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var IsomorphicCSSProvider = _wrapComponent('IsomorphicCSSProvider')((_temp = _class = function (_Component) {
  (0, _inherits3.default)(IsomorphicCSSProvider, _Component);

  function IsomorphicCSSProvider() {
    (0, _classCallCheck3.default)(this, IsomorphicCSSProvider);
    return (0, _possibleConstructorReturn3.default)(this, (IsomorphicCSSProvider.__proto__ || (0, _getPrototypeOf2.default)(IsomorphicCSSProvider)).apply(this, arguments));
  }

  (0, _createClass3.default)(IsomorphicCSSProvider, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return this.props.context;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.Children.only(this.props.children);
    }
  }]);
  return IsomorphicCSSProvider;
}(_react2.Component), _class.propTypes = {
  context: _react2.PropTypes.object.isRequired,
  children: _react2.PropTypes.element.isRequired
}, _class.childContextTypes = {
  insertCss: _react2.PropTypes.func.isRequired
}, _temp));

exports.default = IsomorphicCSSProvider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/IsomorphicCSSProvider.js
// module id = 1696
// module chunks = 47